export default __webpack_public_path__ + "4c2d5d00dbc580fa9449b2a840ab0653.svg";